import logoParlamento from '../../static/img/logo-parlamento.png';
import logoUE from '../../static/img/logo-ue.png';


const CameraHeader = ({ children }) => {

    return (
        <div>
            <header>
                <h1 className="sr-only">Camera dei deputati - Assemblea Costituente</h1>
                <div className="header-top">
                    <div className="container">
                        <div className="grid mt-0">
                            <div className="col-6">
                                <ul className="flex gap-3 align-items-center list-none pt-1 m-0">
                                    <li>
                                        <img alt="Unione Europea" src={logoUE} />
                                    </li>
                                    <li>
                                        <a className="logo-parlamento-italiano" href="https://www.parlamento.it/" target="_blank" title="Vai al sito web del Parlamento Italiano">
                                            <img alt="Vai al sito web del Parlamento Italiano" src={logoParlamento} />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="wrapper-sticky-block">
                    <div className="header-center">
                        <div className="container">
                            <div className="grid mt-0">
                                <div className="col-6 switch-3">
                                    <div className="wrap-logo">
                                        <a href="https://costituente.camera.it" className="text-logo" style={{ textDecoration: "none", color: "inherit" }}>
                                            <span className="text-camera">Camera dei deputati</span>
                                            <div>Assemblea Costituente</div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-6 switch-9">
                                    <div className="wrap-section-name">
                                        <span className="section-name">
                                            <span>Assemblea Costituente</span>
                                        </span>
                                        <span className="section-subtitle">Cerca per data, argomento o nominativo</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-bottom">
                    <div className="container">
                        <div className="grid mt-0">
                            <div className="col-6">
                                <a className="link-camera"style={{textAlign: 'left'}} href="https://costituente.camera.it" title="Vai al sito web dedicato ai lavori della Costituente">vai a costituente.camera.it</a>
                            </div>
                            <div className="col-6">
                                <a className="link-camera" href="https://www.camera.it" title="Vai al sito web della Camera dei deputati">vai a camera.it</a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div id="container" className="container">
                <div className="jumbotron">
                    <p>E' possibile ricercare i dibattiti delle sedute dell'Assemblea Costituente filtrando i risultati per argomento trattato, per deputato o membro del Governo intervenuto, per data e per Organo.</p>
                </div>
                <div className="card mt-0 b-0">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default CameraHeader;
